import Api from "../api/api";

export default {
  firstConfirm() {
    setTimeout(() => {
      const captchaField = document.getElementById("_captchaField");
      captchaField && (captchaField.style.display = "none");
      captchaField && (captchaField.value = Api.CAPTCHA);

      const holidayAction = document.querySelector(
        "select[name=holiday_action]"
      );
      holidayAction && (holidayAction.disabled = true);
      holidayAction && (holidayAction.value = "epaper");
    }, 50);
  }
}
